import { render } from "./shopRecords.vue?vue&type=template&id=8ce68382&scoped=true"
import script from "./shopRecords.vue?vue&type=script&lang=js"
export * from "./shopRecords.vue?vue&type=script&lang=js"

import "./shopRecords.vue?vue&type=style&index=0&id=8ce68382&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8ce68382"

export default script